module.exports = __webpack_public_path__ + "static/stay-in-place-f01afe77d8dd2989a52b630e3c3e0571.jpg";